// Hides the bar while any other xProductCart buy form on the page is on screen, so two never compete.
class UsdcStickyBuyBar extends HTMLElement {
  connectedCallback() {
    this.visible = new Set();
    this.setup = this.setup.bind(this);
    document.addEventListener('shopify:section:load', this.setup);
    document.addEventListener('shopify:section:unload', this.setup);
    this.setup();
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:section:load', this.setup);
    document.removeEventListener('shopify:section:unload', this.setup);
    this.observer?.disconnect();
  }

  setup() {
    this.observer?.disconnect();
    this.visible.clear();

    const targets = [...document.querySelectorAll('main [x-data="xProductCart"]')].filter(
      (target) => !this.contains(target)
    );
    this.classList.remove('is-hidden');
    if (!targets.length) return;

    this.observer = new IntersectionObserver((entries) => {
      for (const { target, isIntersecting } of entries) {
        if (isIntersecting) this.visible.add(target);
        else this.visible.delete(target);
      }
      this.classList.toggle('is-hidden', this.visible.size > 0);
    });

    for (const target of targets) this.observer.observe(target);
  }
}

if (!customElements.get('usdc-sticky-buy-bar')) {
  customElements.define('usdc-sticky-buy-bar', UsdcStickyBuyBar);
}
